export default "__VITE_ASSET__CeQ0Qnza__"